// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"56d5ddf6","27":"0dc5ad90","130":"c60dd4f2","223":"481d3935","252":"678282f5","422":"77256077","458":"7676735c","477":"2a9da662","570":"9376e658","615":"c943b77d","711":"ac894bc3","791":"aabfc622","926":"3f90252d","945":"396feaa8","981":"17affa93"}[chunkId] + ".chunk.js";
};